import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'next-i18next';

import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';
import { useRefreshLinks } from '@phoenix/core/frontend/shared/feature/global-links/use-refresh-links';
import { getLocale } from '@phoenix/core/frontend/shared/util/locales/locales';

const CONTACT_SUPPORT_FALLBACK_URL = 'https://support.stihl.com/en-INT/write-email/';

export const useCustomerSupportLink = (type?: string, serialNumber?: string, topic = 'support'): string => {
  const { t } = useTranslation('shared');
  const { 'customer-support': flagEnabled } = useFlags();
  const { contactSupportForm: linkFromStaticService } = useRefreshLinks([{ id: 'contactSupportForm' }], getLocale(), !flagEnabled);
  const backLink = {
    backUrl: encodeURIComponent(window.location.href),
    backLabel: encodeURIComponent(
      t(`contentful_links_myStihlNavigation_${window.location.pathname.includes('dashboard') ? 'dashboard' : 'toolshed'}_name`) as string
    ),
  };

  if (flagEnabled) {
    const url = new URL(`${window.location.origin}${link('customer-support')}`);
    url.search = new URLSearchParams({
      topic,
      ...(type && { type }),
      ...(serialNumber && { serialNumber }),
      o: 'MySTIHL',
      ...backLink,
    }).toString();

    return url.href;
  }

  return linkFromStaticService?.url && linkFromStaticService.url !== '#' ? linkFromStaticService.url : CONTACT_SUPPORT_FALLBACK_URL;
};
